export const SCENES_UPDATED_EVENT = 'scenes:updated'

export function notifyScenesUpdated() {
  window.dispatchEvent(new Event(SCENES_UPDATED_EVENT))
}
